import { axiosInstance } from "@/lib/axios";
import { API_ENDPOINTS } from "@/lib/api-constants";

export interface LogoutResponse {
  response_schema: {
    response_code: string;
    response_message: string;
  };
  response_output: {
    detail: Record<string, unknown>;
  };
}

export const logout = async (): Promise<LogoutResponse> => {
  return axiosInstance.get(API_ENDPOINTS.AUTH.LOGOUT);
};
